const STATUS_SURVEY = {
  DOING: 'doing',
  DONE: 'done',
  SKIPPED: 'skipped',
};

const SURVEY_TYPE = {
  SIGNUP: 'signup',
};

export { STATUS_SURVEY, SURVEY_TYPE };
